import React from 'react';
import { Search, Clock } from 'lucide-react';

/**
 * DetectionStatus — chip surfacing pipeline state above the subtitle text.
 *
 * status:
 *   - 'idle'              → empty placeholder (subtitles' own placeholder is enough)
 *   - 'detecting'         → "Detecting" with animated dots (hand present, still)
 *   - 'motion-detecting'  → "Detecting motion" with clock icon (Phase 4 temporal)
 *   - 'recognized'        → empty (Subtitles' flash takes over)
 */
export default function DetectionStatus({ status }) {
  if (status === 'detecting') {
    return (
      <div className="sv-detect-status sv-detect-status--on" data-testid="detection-status" data-status="detecting">
        <Search className="w-3.5 h-3.5" strokeWidth={2.4} />
        <span className="sv-detect-status-label">Detecting</span>
        <span className="sv-detect-dots" aria-hidden="true">
          <span />
          <span />
          <span />
        </span>
      </div>
    );
  }
  if (status === 'motion-detecting') {
    return (
      <div
        className="sv-detect-status sv-detect-status--motion"
        data-testid="detection-status"
        data-status="motion-detecting"
      >
        <Clock className="w-3.5 h-3.5" strokeWidth={2.4} />
        <span className="sv-detect-status-label">Detecting motion</span>
        <span className="sv-detect-dots" aria-hidden="true">
          <span />
          <span />
          <span />
        </span>
      </div>
    );
  }
  return (
    <div
      className="sv-detect-status sv-detect-status--placeholder"
      data-testid="detection-status"
      data-status={status || 'idle'}
    />
  );
}
